import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useSkeleton from "../../../../hooks/useSkeleton";

import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";

import helperFormats from "../../../../utils/helperFormats";

/**
 * Pide la fecha con la que se van a emitir los comprobantes de la retención. Es lo único que hay
 * que decidir antes de facturar: el cobro ya está firme.
 *
 * La fecha queda fija para toda la retención en cuanto sale el primer comprobante, porque lo
 * emitido no se puede rehacer y no puede haber comprobantes de una misma retención con fechas
 * distintas. Mientras no salió ninguno, se puede corregir.
 */
const WithholdingsBillingDate = ({ settings }) => {
  const { t } = useTranslation();
  const s = useSkeleton("abm");

  const frozenDate = settings.billingDateFrozen
    ? new Date(settings.billingDate)
    : null;

  // Por defecto la de hoy, salvo que la retención ya tenga una elegida.
  const [billingDate, setBillingDate] = useState(
    frozenDate ??
      (helperFormats.isDate(settings.billingDate)
        ? new Date(settings.billingDate)
        : new Date())
  );

  // El proveedor no acepta comprobantes con fecha anterior al 01/10/2011 ni a más de dos meses a
  // futuro. Se acota acá para no gastar un intento por comprobante averiguándolo.
  const today = new Date();
  const maxDate = new Date(
    today.getFullYear(),
    today.getMonth() + 2,
    today.getDate()
  );

  return (
    <React.Fragment>
      <div className={s.get()}>
        <div className="flex flex-column">
          <p>
            {t("entities.withholdings.billingDialogHelp", {
              count: settings.pendingBillingCount,
            })}
          </p>

          <div className="flex flex-column mt-2">
            <label htmlFor="billingDate">
              {t("entities.withholdings.billingDate")}
            </label>
            <div className="form-crud mt-2">
              <Calendar
                id="billingDate"
                value={billingDate}
                onChange={(event) => setBillingDate(event.value)}
                dateFormat="dd/mm/yy"
                showIcon
                readOnlyInput
                minDate={new Date(2011, 9, 1)}
                maxDate={maxDate}
                disabled={settings.billingDateFrozen}
              />
            </div>
          </div>

          <div className="flex flex-column mt-4" style={{ gap: "4px" }}>
            {settings.billingDateFrozen ? (
              <small style={{ color: "#a16207" }}>
                {t("entities.withholdings.billingDateFrozenHelp", {
                  date: helperFormats.formatDate(frozenDate),
                })}
              </small>
            ) : (
              <small>{t("entities.withholdings.billingDateHelp")}</small>
            )}
          </div>

          <div className="flex justify-content-between mt-4 mb-2">
            <Button
              label={t("buttons.cancel")}
              icon="pi pi-times"
              className="p-button-text btn-secondary-crud"
              onClick={() => settings.hideDialog("CANCEL")}
              type="button"
            />
            <Button
              label={t("entities.withholdings.bill")}
              icon="pi pi-file"
              className="btn btn-primary btn-primary-crud"
              onClick={() => settings.bill(billingDate)}
              type="button"
              disabled={!billingDate}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default WithholdingsBillingDate;
